import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { InstrumentTypeResponse } from "../../../codegen-api";
import { findTradingTypeByInstrument, getEnabledInstrumentTypes } from "../../../config/features";
import { Select } from "../../shared/Select";

interface IPortfolioMarketFilterProps {
  title: string;
  instrumentType?: InstrumentTypeResponse;
  onSetFilter: (type?: InstrumentTypeResponse) => void;
}

/**
 * Instrument-type filter shared by the Positions, Orders and history tabs.
 *
 * The options come from the trading-type registry, so a vertical that is
 * switched off for this build never appears here. `undefined` ("all markets")
 * is always first and is deliberately unfiltered — a user who still holds a
 * position in a since-disabled vertical can see and close it.
 */
export function PortfolioMarketFilter({ title, instrumentType, onSetFilter }: IPortfolioMarketFilterProps) {
  const { t } = useTranslation("app", { keyPrefix: "PortfolioSettings.PortfolioMarketFilter" });
  const { t: tTradingType } = useTranslation("app", { keyPrefix: "tradingTypes" });

  const filters: (InstrumentTypeResponse | undefined)[] = useMemo(
    () => [undefined, ...getEnabledInstrumentTypes()],
    []
  );

  return (
    <Select
      isRound
      options={filters.map((filter) => ({
        label: filter
          ? tTradingType(findTradingTypeByInstrument(filter)?.shortLabelKey ?? "")
          : `${t("all")} ${title}`,
        isActive: filter === instrumentType,
        onClick: () => onSetFilter(filter),
      }))}
    />
  );
}
